import { getChakraColorScale as V, getColorsList as A, hexToNumber as F, isValidHex as $ } from "./myasurion-shared.colors.es.js";
import { j as C, v as s, w as h } from "./useAccount-a03adfa5.js";
import { c as J, f as L, e as M, g as N, b as P, k as z, m as D, h as O, i as U, n as W, d as q, p as B, l as G, t as K } from "./useAccount-a03adfa5.js";
import { Mixpanel as R } from "./myasurion-shared.mixpanel.es.js";
import "./lodash-9598aa3c.js";
import "react";
import "./domains-7d097fe4.js";
import "mixpanel-browser";
async function I(r, o, i, l, a) {
  var c, e;
  try {
    if (!a || !i)
      return null;
    const t = await C(a);
    if (!t)
      return null;
    const n = s(t, o).asString(), g = s(t, i).asString(), p = s(t, l).asString(), u = (await h.createClient({
      space: n,
      accessToken: g,
      environment: p
    }).getEntries({
      content_type: "genericIdImageDescriptionSlug",
      "fields.slug": r
    })).items[0].fields.image;
    return ((e = (c = u == null ? void 0 : u.fields) == null ? void 0 : c.file) == null ? void 0 : e.url) || null;
  } catch (t) {
    throw console.error("Error fetching entry:", t), t;
  }
}
async function T(r, o, i, l, a, c, e) {
  var t;
  try {
    const n = await C(c);
    if (!n)
      return null;
    const g = s(n, i).asString(), p = s(n, l).asString(), m = s(n, a).asString(), f = await h.createClient({
      space: g,
      accessToken: p,
      environment: m
    }).getEntries({
      content_type: o,
      ...r
    });
    return (e ? f.items : (t = f.items[0]) == null ? void 0 : t.fields) || null;
  } catch (n) {
    return console.error("Error fetching entry:", n), n || null;
  }
}
async function k(r, o, i, l, a, c) {
  try {
    const e = await C(c);
    if (!e)
      return null;
    const t = s(e, i).asString(), n = s(e, l).asString(), g = s(e, a).asString();
    return await h.createClient({
      space: t,
      accessToken: n,
      environment: g
    }).getEntries({
      content_type: o,
      ...r
    }) || null;
  } catch (e) {
    return console.error("Error fetching entry:", e), e || null;
  }
}
const v = (r) => `${r}?fm=jpg&fl=progressive`, b = (r, o = null) => `${r}?fm=webp${o ? "&q=" + o : ""}`;
export {
  R as Mixpanel,
  J as generateAuthorization,
  L as generateMixpanelId,
  M as generateTokenTimestamp,
  N as generateUrl,
  P as getAuthTokens,
  V as getChakraColorScale,
  A as getColorsList,
  k as getCompleteContentfulEntry,
  T as getContentfulEntry,
  I as getContentfulImage,
  z as getFirebaseConfigValue,
  C as getFirebaseRemoteConfig,
  D as getHomeLink,
  O as hashFn,
  F as hexToNumber,
  U as isAuthenticated,
  $ as isValidHex,
  W as noop,
  q as parseHttpPath,
  B as parseJSON,
  G as printVersion,
  v as processContentfulImageToProgressiveJpg,
  b as processContentfulImageToWebp,
  K as timeConvert24to12Hr
};
